import {
  PERMISSION_RECORDS_EDIT_ID,
  PERMISSION_RECORDS_VIEW_ID,
} from '@/constants/permissions';
import { ACCESS_PERMISSIONS } from '@/constants/permissions';
import { Permission } from '@/types/Permissions';
import { UseFormReturnType } from '@mantine/form';

export function checkRoutePermission(
  userPerms: Permission[] | undefined,
  pathname: string
): boolean {
  try {
    const routeSegment = pathname.split('/')[1]
      ? `/${pathname.split('/')[1]}`
      : '/';
    const requiredPermissions = ACCESS_PERMISSIONS[routeSegment];
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }

    if (!userPerms || userPerms.length === 0) {
      return false;
    }

    // User needs at least one of the required permissions
    return userPerms.some((perm) =>
      requiredPermissions.includes(perm.code_name)
    );
  } catch (error) {
    console.error('Error checking permissions:', error);
    return false;
  }
}

export const createPermissionChangeHandler = <T extends { groups?: number[] }>(
  form: UseFormReturnType<T>
) => {
  return (permissionId: number, checked: boolean) => {
    try {
      const currentPermissions = form.getValues().groups || [];

      const addPermissionsToUser = (ids: number[]) => {
        const newIds = ids.filter((id) => !currentPermissions.includes(id));
        if (newIds.length > 0)
          form.setFieldValue('groups', [
            ...currentPermissions,
            ...newIds,
          ] as any);
      };

      const removePermissionsToUser = (ids: number[]) => {
        const newPermissions = currentPermissions.filter(
          (permissionId) => !ids.includes(permissionId)
        );
        if (newPermissions.length < currentPermissions.length) {
          form.setFieldValue('groups', newPermissions as any);
        }
      };

      switch (permissionId) {
        case PERMISSION_RECORDS_EDIT_ID:
          return checked
            ? addPermissionsToUser([
                PERMISSION_RECORDS_EDIT_ID,
                PERMISSION_RECORDS_VIEW_ID,
              ])
            : removePermissionsToUser([PERMISSION_RECORDS_EDIT_ID]);

        case PERMISSION_RECORDS_VIEW_ID:
          return checked
            ? addPermissionsToUser([PERMISSION_RECORDS_VIEW_ID])
            : removePermissionsToUser([
                PERMISSION_RECORDS_VIEW_ID,
                PERMISSION_RECORDS_EDIT_ID,
              ]);

        default:
          return checked
            ? addPermissionsToUser([permissionId])
            : removePermissionsToUser([permissionId]);
      }
    } catch (error) {
      console.error('Error updating permission:', error);
    }
  };
};
